import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import AppShell from "@/components/AppShell";

export default function Terms() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const useItems = t("terms.useItems", { returnObjects: true });
  return (
    <AppShell>
      <div className="md:max-w-2xl md:mx-auto">
        <div className="px-5 pt-1 flex items-center gap-3" data-testid="terms-page">
          <button
            onClick={() => navigate(-1)}
            aria-label={t("common.back")}
            data-testid="terms-back"
            className="w-9 h-9 rounded-full bg-white border border-[#E8E5DF] flex items-center justify-center text-leaf-ink"
          >
            <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
          </button>
          <h1 className="font-display text-3xl text-leaf-ink leading-tight">{t("terms.title")}</h1>
        </div>

        <div className="px-5 mt-6 space-y-5 pb-2 text-leaf-ink leading-relaxed">
          <p className="text-xs uppercase tracking-[0.18em] text-leaf-mist">{t("terms.lastUpdated")}</p>
          <Section title={t("terms.acceptTitle")}>{t("terms.accept")}</Section>
          <Section title={t("terms.descTitle")}>{t("terms.desc")}</Section>
          <Section title={t("terms.accuracyTitle")}>{t("terms.accuracy")}</Section>
          <section className="bg-white rounded-3xl border border-[#E8E5DF] p-5">
            <h2 className="text-xs uppercase tracking-[0.18em] font-medium text-leaf">{t("terms.useTitle")}</h2>
            <ul className="mt-3 list-disc pl-5 space-y-1.5">
              {Array.isArray(useItems) && useItems.map((it) => <li key={it}>{it}</li>)}
            </ul>
          </section>
          <Section title={t("terms.accountTitle")}>{t("terms.account")}</Section>
          <Section title={t("terms.liabTitle")}>{t("terms.liab")}</Section>
          <Section title={t("terms.changesTitle")}>{t("terms.changes")}</Section>
          <Section title={t("terms.contactTitle")}>
            {t("terms.contact")} <Link to="/privacy" className="text-leaf underline">{t("login.privacy")}</Link>
          </Section>
        </div>
      </div>
    </AppShell>
  );
}

const Section = ({ title, children }) => (
  <section className="bg-white rounded-3xl border border-[#E8E5DF] p-5">
    <h2 className="text-xs uppercase tracking-[0.18em] font-medium text-leaf">{title}</h2>
    <div className="mt-3"><p>{children}</p></div>
  </section>
);
